import { JsonPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarAction,
  MatSnackBarActions,
  MatSnackBarLabel,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { MessagePayload, NotificationPayload } from 'firebase/messaging';

@Component({
  selector: 'app-notification-snack-bar',
  imports: [
    MatButtonModule,
    MatSnackBarLabel,
    MatSnackBarAction,
    MatSnackBarActions,
    MatIconModule,
  ],
  templateUrl: './notification-snack-bar.component.html',
  styleUrl: './notification-snack-bar.component.css',
})
export class NotificationSnackBarComponent {
  public message = inject<MessagePayload>(MAT_SNACK_BAR_DATA);
  public snackBarRef = inject(MatSnackBarRef);
}
